export default {
  path: '/drug-formula',
  component: () => import('@/views/drug-formula/DrugFormula.vue'),
  children: [
    {
      path: '',
      name: 'DrugFormulaList',
      component: () => import('@/views/drug-formula/pages/DrugFormulaList.vue'),
      meta: {
        name: 'navigationDrawer.drugFormulaList',
        icon: '/icons/drug.svg',
        auth: true
      }
    },
    {
      path: 'create',
      name: 'DrugFormulaCreate',
      component: () => import('@/views/drug-formula/pages/DrugFormulaCreate.vue'),
      meta: {
        name: 'navigationDrawer.drugFormulaList',
        icon: '/icons/drug.svg',
        auth: true
      }
    },
    {
      path: 'edit/:id',
      name: 'DrugFormulaEdit',
      component: () => import('@/views/drug-formula/pages/DrugFormulaEdit.vue'),
      meta: {
        name: 'navigationDrawer.drugFormulaList',
        icon: '/icons/drug.svg',
        auth: true
      }
    },
    {
      path: 'unit/:id',
      name: 'DrugFormulaUnit',
      component: () => import('@/views/drug-formula/pages/DrugFormulaUnit.vue'),
      meta: {
        name: 'navigationDrawer.drugFormulaList',
        icon: '/icons/drug.svg',
        auth: true
      }
    },
    {
      path: 'detail/:id',
      name: 'DrugFormulaDetail',
      component: () => import('@/views/drug-formula/pages/DrugFormulaDetail.vue'),
      meta: {
        name: 'navigationDrawer.drugFormulaList',
        icon: '/icons/drug.svg',
        auth: true
      }
    },
    {
      path: 'print-drugformula',
      name: 'PrintDrugFormula',
      component: () => import('@/views/drug-formula/components/PrintDrugFormula.vue'),
      meta: {
        auth: true,
        layout: 'blank'
      }
    }
  ]
}
